import {
  Component,
  h,
  Host,
  ComponentInterface,
  Prop,
  Event,
  EventEmitter,
} from '@stencil/core';

@Component({
  tag: 'signet-pdf-pagination',
  styleUrl: 'signet-pdf-pagination.scss',
})
export class SignetPdfPagination implements ComponentInterface {
  @Prop() label: string;
  @Event() nextClick: EventEmitter<void>;
  @Event() previousClick: EventEmitter<void>;

  handleNextClick() {
    this.nextClick.emit();
  }

  handlePreviousClick() {
    this.previousClick.emit();
  }

  render() {
    const classes = {
      'signet-pdf-pagination': true,
    };

    return (
      <Host class={classes}>
        <div class="container">
          <p class="label">{this.label}</p>
          <div class="icon-container">
            <signet-icon
              icon="keyboard_arrow_up"
              onClick={() => this.handlePreviousClick()}
              class="icon"
            />
            <signet-icon
              icon="keyboard_arrow_down"
              onClick={() => this.handleNextClick()}
              class="icon"
            />
          </div>
        </div>
      </Host>
    );
  }
}
